'use strict';

const { redirectToTaskWhenMediaReviewNotAllowed } = require('./redirects');

const mediaApprovalStates = ({ elm }) => {
	return [
		elm({
			name: 'site.MediaApproval',
			moduleName: 'Locations.MediaApproval.Main',
			url: '/media/approval?f&filter',
			requiredPermission: 'permission/location.edit',
			pageTitle: 'listings.media_approval',
			redirectTo: redirectToTaskWhenMediaReviewNotAllowed,
			argsResolver: [
				'pmtEnvService',
				'$stateParams',
				(pmtEnvService, $stateParams) => {
					const siteName = $stateParams.site || $stateParams.siteName;
					console.log('baseUrl', pmtEnvService.listingsManagerUrl + siteName + '/media/approval');
					return {
						currentUrl: pmtEnvService.listingsManagerUrl + siteName + '/media/approval'
					};
				}
			]
		})
	];
};

const mediaStates = ({ elm }) => {
	return [
		elm({
			name: 'site.MediaReview',
			moduleName: 'Locations.MediaReview.Main',
			url: '/mediareview?f&filter',
			requiredPermission: 'permission/location.view',
			pageTitle: 'listings.navigation.media_review',
			redirectTo: redirectToTaskWhenMediaReviewNotAllowed
		})
	];
};

const assetsStates = ({ angular }) => {
	return [
		{
			name: 'site.AssetsList',
			url: '/assets?view&f&d',
			params: {
				view: {
					value: '',
					squash: true
				}
			},
			redirectTo: trans => {
				const params = trans.params();
				const auth = trans.injector().get('auth');

				if (!params.view && params.site) {
					return auth.getUser(params.site).then(user => {
						return { params: { ...params, view: user.settings.mediaListView || 'list' } };
					});
				}
			},
			reloadOnSearch: false,
			component: 'pmtAssetManager',
			requiredPermission: 'permission/media.view'
		},
		{
			name: 'site.AssetsView',
			url: '/assets/:assetId',
			component: 'pmtAssetView',
			requiredPermission: 'permission/media.view',

			resolve: {
				prevState: [
					'$state',
					$state => {
						return {
							name: $state.current.name,
							params: angular.copy($state.params),
							url: $state.current.url
						};
					}
				]
			}
		}
	];
};

module.exports = {
	mediaApprovalStates,
	mediaStates,
	assetsStates
};
